module.exports = __webpack_public_path__ + "static/media/thumbnail.dfa13e4b.jpg";